<template>
  <v-card outlined class="py-0 px-0 ml-3 mb-2 note-card card-content elevation-0">
    <v-row class="pr-4 pl-2 pt-1" no-gutters>
      <v-col class="shrink pr-3">
        <page-type-icon size="18" :pageType="item.type" class="pr-0"></page-type-icon>
      </v-col>
      <v-col class="font-weight-medium pt-1" style="font-size: 14px;">
        {{ title }}
      </v-col>
      
      <v-divider
        class="col-12 my-1 py-0"
        :style="closed ? 'opacity: 0;' : 'opacity: 1;'"
      ></v-divider>
    </v-row>

    <v-row no-gutters class="">
      <v-col class="caption px-4 grey--text text--lighten-1">
        Hidden {{ item.noteCardSortDate | formatDate('fromNow') }}
      </v-col>
      <v-col class="shrink">
        <v-btn small icon @click="$emit('revert')" class="mr-4">
          <oh-v-icon name="md-undo"></oh-v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <open-btn
      v-if="!hideAction"
      style="position: absolute; right: 1px; top: 1px; width: 150px; text-align: right; z-index: 10;"
      :showDelete="true"
      @delete="deleteBranch(item)"
      @open="openInTab({ pageId: item.id })"
      @openNewTab="openInTab({ pageId: item.id })"
      @addToMyPanel="addNoteToTeammate({ addToSelf: true, pageId: item.id })"
    ></open-btn>
  </v-card>
</template>

<script>
import { computed, ref } from '@vue/composition-api';
import PageTypeIcon from '@/components/ContextDoc/PageTypeIcon';
import { deleteBranch, addNoteToTeammate } from '@/components/ContextDoc/use/useDocActions';
import useWorkspace from '@/views/Context/use/useWorkspace';
import OpenBtn from '@/components/ContextDoc/OpenBtn';
import { currentUserId } from '@/store/useAuth';

export default {
  props: ['item', 'rootId', 'collapsible', 'startClosed', 'hideAction'],
  components: { PageTypeIcon, OpenBtn },
  setup(props) {
    const { openInTab } = useWorkspace();
    const title = computed(() => {
      const t = props.item.title;
      const tempDoc = new DOMParser().parseFromString(t, 'text/html');
      return tempDoc.body.textContent || '';
    });
    // const children = computed(() => {
    //   const childs = [];
    //   Object.values(props.item.page.pageNotes).forEach(n => {
    //     if (n && n.id && !n.toDelete) {
    //       const page = pagesModule.doc(n.pageId).data;
    //       const t = page.title;
    //       const tempDoc = new DOMParser().parseFromString(t, 'text/html');
    //       let title = tempDoc.body.textContent || '';
    //       if (title.length > 43) title = title.slice(0, 40) + '...';
    //       const subChildren = [];
    //       Object.values(page.pageNotes).forEach(n => {
    //         if (n && n.id && !n.toDelete) {
    //           const page = pagesModule.doc(n.pageId).data;
    //           const t = page.title;
    //           const tempDoc = new DOMParser().parseFromString(t, 'text/html');
    //           let title = tempDoc.body.textContent || '';
    //           if (title.length > 20) title = title.slice(0, 17) + '...';
    //           if (title.length) {
    //             subChildren.push({ order: n.order, title, type: page.type, id: page.id });
    //           }
    //         }
    //       });

    //       childs.push({
    //         order: n.order,
    //         title,
    //         type: page.type,
    //         id: page.id,
    //         children: subChildren.sort((a, b) => a.order - b.order)
    //       });
    //     }
    //   });
    //   return childs.sort((a, b) => a.order - b.order);
    // });

    return { title, openInTab, closed, deleteBranch, currentUserId, addNoteToTeammate };
  }
};
</script>

<style>
.section-link:hover {
  background: #f6f6f6;
  cursor: pointer;
}

.note-card {
  max-height: 500px;
  transition: 0.3s ease max-height, 0.3s ease box-shadow;
  overflow: hidden;
}

.note-card.closed {
  max-height: 30px;
}
</style>
